import { useHistory } from 'react-router-dom';
import FormFooter from '../../../../components/StickyFooter/FormFooter';
import UnsavedFormDataPrompt from '../../../../components/UnsavedDataPrompt/UnsavedFormDataPrompt';
import ValuationMethodWarningDialog from '../Dialogs';

interface PageFooterProps {
  isDirty: boolean;
  isWarningDialogOpen: boolean;
  isUnsavedPromptOpen: boolean;
  isSaving?: boolean;
  hasErrors?: boolean;
  onCancel: () => void;
  onSave: () => void;
  onDiscardChanges: () => void;
  onCancelDiscard: () => void;
  onDialogClose: () => void;
  onDialogContinue: () => void;
}

function PageFooter({
  isDirty,
  isWarningDialogOpen,
  isUnsavedPromptOpen,
  isSaving = false,
  hasErrors = false,
  onCancel,
  onSave,
  onDiscardChanges,
  onCancelDiscard,
  onDialogClose,
  onDialogContinue,
}: PageFooterProps) {
  const history = useHistory();

  return (
    <>
      {isDirty && (
        <FormFooter
          buttons={[
            {
              onClick: onCancel,
              dataTestId: 'cancel-button',
              name: 'buttonText.cancel',
              disabled: isSaving,
            },
            {
              onClick: onSave,
              dataTestId: 'save-button',
              submitType: true,
              disabled: isSaving || hasErrors,
            },
          ]}
        />
      )}
      <UnsavedFormDataPrompt
        when={isDirty}
        open={isUnsavedPromptOpen}
        onConfirm={onDiscardChanges}
        onCancel={onCancelDiscard}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={() => isDirty}
      />
      <ValuationMethodWarningDialog open={isWarningDialogOpen} onClose={onDialogClose} onContinue={onDialogContinue} />
    </>
  );
}

PageFooter.defaultProps = {
  isSaving: false,
  hasErrors: false,
};

export default PageFooter;
